import { render, staticRenderFns } from "./MoveToDisbursed.vue?vue&type=template&id=31e7a4d2&scoped=true"
import script from "./MoveToDisbursed.vue?vue&type=script&lang=js"
export * from "./MoveToDisbursed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e7a4d2",
  null
  
)

export default component.exports